export default "__VITE_ASSET__Lcqg$Ijt__"